import { env, giftCodeExperienceURL } from 'endpoints';
import fetch from '../utils/fetch';
import { startLoading, endLoading, setAlertMessage } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	successSubmit: false
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_SUCCESS = 'SET_SUCCESS';

/*******************************************************************************
 * Reducer
 */
export default function ContactUsPage( state = initialState, action ) {
	switch ( action.type ) {
		case SET_SUCCESS:
			return {
				...state,
				successSubmit: action.success
			};
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */

export function contactUs( data ) {
	return ( dispatch, getState ) => {
		const state = getState();

		dispatch( startLoading() );

		let contactEmail = state.company.contactEmailAddress || ( env ? 'cpd+contactus@email-testing.biw-labs.com' : 'programawardcenter@biworldwide.com' );

		return fetch( `${ giftCodeExperienceURL }/sendContactUsEmail`, {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify(
				{
					code: `${ data.code }`, 
					siteUrl: `${ data.siteUrl }`, 
					name: `${ data.name }`, 
					fromEmailAddress: `${ data.email }`, 
					otherText: `${ data.otherText }`, 
					country: `${ data.country }`, 
					question: `${ data.question }`, 
					companyName: `${ data.companyName }`, 
					contactEmailAddress: `${ contactEmail }` 
				}
			)
		} )
			.then( ( res ) => {
				if ( res.ok ) {
					return res.json().then( ( response ) => {
						if ( response.success === true ) {
							dispatch( setSuccess( true ) );
							dispatch( endLoading() );
							return true;
						} else {
							dispatch( setAlertMessage( 'giftCode.error.unknownError', 'DANGER' ) );
							// console.error( response.data.sendContactUsEmail.messages || JSON.stringify( response.errors ) );
							dispatch( endLoading() );
						}
					} );
				} else {
					return res.json().then( ( response ) => {
						dispatch( setAlertMessage( 'giftCode.error.unknownError', 'DANGER' ) );
						dispatch( endLoading() );
					} );
				}
			} )
			.catch ( ( err ) => {
				dispatch( setAlertMessage( 'giftCode.error.unknownError', 'DANGER' ) );
				console.error( err );
				dispatch( endLoading() );
			} );
	};
}

export function setSuccess ( success ) {
	return {
		type: SET_SUCCESS,
		success
	};
}